import { ToastContainer } from '../../components/Common';
import DocumotoPageDetailPage from './page';

const DocumotoPageDetailPageWrapper = () => (
	<>
		<div className="page-content">
			<DocumotoPageDetailPage />
		</div>
		<ToastContainer />
	</>
);

export default DocumotoPageDetailPageWrapper;
